module.exports = __webpack_public_path__ + "img/PDAC1_CD8Tex.24780aa7.png";